import axios from 'axios';
import _ from "lodash";

export const register = async (userDetails) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/partner/referer`,
      userDetails
    );
    localStorage.setItem('jwt', response.headers['x-jwt-token']);
    return response.data;
  } catch (error) {
    return { error: true };
  }
};

export const generateOTP = async (mobileNumber) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/partner/referer/login`,
      {
        mobileNumber
      }
    );
    return response.data?.data;
  } catch (error) {
    return { sendOTP: false, error: error.response.data?.data };
  }
};

export const verifyPhoneNumberAndOTP = async (mobileNumber, otp) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/partner/referer/verifyOTP`,
      {
        mobileNumber,
        otp
      }
    );
    localStorage.setItem('jwt', response.headers['x-jwt-token']);
    return response.data?.data;
  } catch (error) {
    return { error: error.response.data?.data };
  }
};

export const verifyPhoneNumberAndOTPForLogin = async (mobileNumber, otp) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/partner/referer/verifyLoginOTP`,
      {
        mobileNumber,
        otp
      }
    );
    localStorage.setItem('jwt', response.headers['x-jwt-token']);
    return response.data?.data;
  } catch (error) {
    return { error: error.response.data?.data };
  }
};

export const resendOTP = async ({ mobileNumber }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/partner/referer/resendOTP`,
      {
        mobileNumber
      }
    );
    return response.data?.data;
  } catch (error) {
    return { error: error.response.data?.data };
  }
};

export const getPartnerDetails = async (getMetricsReq) => {
  try {
    axios.defaults.headers.common['x-jwt-token'] = localStorage.getItem('jwt');
    axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
      'jwt'
    )}`;
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/partner/referer/details?startDate=${getMetricsReq.startDate}&endDate=${getMetricsReq.endDate
      }`
    );
    return response.data;
  } catch (error) {
    return { error: true };
  }
};

export const checkPhone = async (checkPhoneRequest) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/partner/referer/checkPhone`,
      checkPhoneRequest
    );
    return response.data;
  } catch (error) {
    return { error: true };
  }
};

// export const verifyPhoneOTP = async (verifyPhoneRequest) => {
//   try {
//     const response = await axios.post(
//       `${process.env.REACT_APP_API_BASE_URL}/api/v1/verify-otp`,
//       verifyPhoneRequest
//     );
//     return response.data;
//   } catch (error) {
//     return { error: true };
//   }
// };

export const updateBankDetails = async (bankDetails) => {
  try {
    axios.defaults.headers.common['x-jwt-token'] = localStorage.getItem('jwt');
    axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
      'jwt'
    )}`;
    const response = await axios.patch(
      `${process.env.REACT_APP_API_BASE_URL}/partner/referer/bankDetails`,
      bankDetails
    );
    return response.data;
  } catch (error) {
    return { error: true };
  }
};

export const getBankDetails = async () => {
  try {
    axios.defaults.headers.common['x-jwt-token'] = localStorage.getItem('jwt');
    axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
      'jwt'
    )}`;
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/partner/referer/profile`
    );
    return response.data;
  } catch (error) {
    return { error: true };
  }
};

export const getMetrics = async (getMetricsReq) => {
  try {
    axios.defaults.headers.common['x-jwt-token'] = localStorage.getItem('jwt');
    axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
      'jwt'
    )}`;
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL
      }/partner/referer/metrics?startDate=${getMetricsReq.startDate}&endDate=${getMetricsReq.endDate
      }`
    );
    return response.data;
  } catch (error) {
    return { error: true };
  }
};

export const getCountries = async (countryCode) => {
  try {
    axios.defaults.headers.common['x-jwt-token'] = localStorage.getItem('jwt');
    axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
      'jwt'
    )}`;
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL
      }/common/data/countries`
    );
    if (!_.isEmpty(response.data)) {
      return response.data.find((country) => { return country.code === countryCode })
    }
    else {
      return null;
    }

  } catch (error) {
    return { error: true };
  }
};